// src/components/TemplateMiniPreview.js
import React from 'react';
import { THEMES, DEFAULT_THEME } from '../templates/themes';
import { iconForCategory } from './ui/Icons';

// Formato de fecha corto por plantilla
const fmtDate = (dateStr, withYear = true) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const opts = { day: '2-digit', month: 'short' };
  if (withYear) opts.year = 'numeric';
  return d.toLocaleDateString('es-PE', opts).toUpperCase();
};

// Obtiene la línea principal según categoría
function getHeroLine(category, data) {
  const d = data || {};
  if (category === 'Matrimonios') {
    return { primary: `${d.bride || 'María'} & ${d.groom || 'Carlos'}`, secondary: null };
  }
  if (category === 'Cumpleaños') {
    return {
      primary: d.name || 'Sofía',
      secondary: d.age ? `Cumple ${d.age} años` : null,
    };
  }
  if (category === 'Baby Shower') {
    return { primary: d.babyName || 'Mateo', secondary: d.parents || null };
  }
  if (category === 'Bautizos') {
    return { primary: d.child || 'Isabella', secondary: null };
  }
  if (category === 'Graduaciones') {
    return { primary: d.graduate || 'Diego', secondary: d.career || null };
  }
  return { primary: 'Mi evento', secondary: null };
}

// Etiqueta superior por categoría
function getLabel(category) {
  const map = {
    Matrimonios: 'NOS CASAMOS',
    'Cumpleaños': '¡ESTÁS INVITADO!',
    'Baby Shower': 'BABY SHOWER',
    Bautizos: 'BAUTIZO',
    Graduaciones: 'GRADUACIÓN',
  };
  return map[category] || 'EVENTO';
}

export default function TemplateMiniPreview({ slug, category, data, size = 'md' }) {
  const theme = THEMES[slug] || DEFAULT_THEME;
  const p = theme.palette;
  const f = theme.fonts;

  const hero = getHeroLine(category, data);
  const label = getLabel(category);
  const CategoryIcon = iconForCategory(category);

  const date = fmtDate(data?.date);
  const place = data?.place || data?.church || data?.reception;

  // Escala de tamaños
  const sizes = {
    sm: { icon: 'w-6 h-6', label: 'text-[8px]', hero: 'text-base', secondary: 'text-[10px]', date: 'text-[10px]' },
    md: { icon: 'w-10 h-10', label: 'text-[10px]', hero: 'text-xl', secondary: 'text-xs', date: 'text-xs' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      className="w-full h-full flex flex-col items-center justify-center relative px-4 text-center"
      style={{ background: p.bg, color: p.dark }}
    >
      {/* Icono de categoría */}
      <div
        className={`${s.icon} mb-3 opacity-90`}
        style={{ color: p.primary }}
      >
        <CategoryIcon className="w-full h-full" />
      </div>

      {/* Etiqueta */}
      <p
        className={`${s.label} tracking-[0.3em] mb-2 font-semibold`}
        style={{ color: p.primary, fontFamily: f.heading }}
      >
        {label}
      </p>

      {/* Nombre principal */}
      <p
        className={`${s.hero} leading-tight mb-1 font-bold`}
        style={{ fontFamily: f.heading, color: p.dark }}
      >
        {hero.primary}
      </p>

      {/* Subtítulo */}
      {hero.secondary && (
        <p
          className={`${s.secondary} mt-1`}
          style={{ fontFamily: f.body, color: p.muted }}
        >
          {hero.secondary}
        </p>
      )}

      {/* Fecha */}
      {date && (
        <p
          className={`${s.date} mt-3 tracking-widest`}
          style={{ fontFamily: f.body, color: p.primary, fontWeight: 500 }}
        >
          {date}
        </p>
      )}

      {/* Lugar */}
      {place && size !== 'sm' && (
        <p
          className={`${s.secondary} mt-1 opacity-70`}
          style={{ fontFamily: f.body, color: p.muted }}
        >
          {place}
        </p>
      )}
    </div>
  );
}